document.addEventListener('DOMContentLoaded', () => {
  const stickyContainer = document.getElementById('sticky-container');
  const hideTargets = document.querySelectorAll('.product [data-hide-sticky]');

  if (!stickyContainer || hideTargets.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    const isVisible = entries.some(entry => entry.isIntersecting);
    stickyContainer.classList.toggle('u-hidden', isVisible);
  }, {
    threshold: 0.1
  });

  hideTargets.forEach(target => observer.observe(target));
});

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

document.addEventListener('DOMContentLoaded', function () {
  const stickyBtn = document.querySelector('.block_producy-stickybtn');

  if (!stickyBtn) return;

  // Set initial state
  stickyBtn.style.display = 'none';

  // Offset thresholds
  const mobileOffset = 200;  // px
  const desktopOffset = 1000; // px

  function getScrollThreshold() {
    return window.innerWidth <= 768 ? mobileOffset : desktopOffset;
  }

  function toggleStickyBtnDesk() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > getScrollThreshold()) {
      stickyBtn.style.display = 'block';
    } else {
      stickyBtn.style.display = 'none';
    }
  }

  function toggleStickyBtnMobile() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > getScrollThreshold() && !$('.cyc-product-qtybuy-container').isInViewport()) {
      stickyBtn.style.display = 'block';
      $("#google-merchantwidget-iframe-wrapper").hide();
    } else {
      stickyBtn.style.display = 'none';
      $("#google-merchantwidget-iframe-wrapper").show();
    }
  }

  // Listen to scroll
  if(window.innerWidth <= 768){
    window.addEventListener('scroll', toggleStickyBtnMobile);
  }else{
    window.addEventListener('scroll', toggleStickyBtnDesk);
  }

});

$(document).ready(function() {
    $(document).on('click', '.cycstickyatcbutton', function(){
				$('.cycproductorderbutton').trigger('click');
			});
});